// Shared colors and Recharts props for the Security Operations (/soc) charts. Every color is a CSS
// custom property from styles/theme.css, so charts follow the light and dark themes; no hex here.

// Categorical series, fixed order, never cycled.
export const SERIES = [
  "var(--soc-series-1)",
  "var(--soc-series-2)",
  "var(--soc-series-3)",
  "var(--soc-series-4)",
  "var(--soc-series-5)",
];

export const SEVERITY = {
  critical: "var(--risk-critical)",
  high: "var(--risk-high)",
  medium: "var(--risk-medium)",
  low: "var(--risk-low)",
};

// Tile status colors, the same tokens SocTile's status pill uses.
export const STATUS = {
  critical: "var(--status-error)",
  warning: "var(--status-warning)",
  good: "var(--status-success)",
};

// The SOC console palette (theme.css --soc-v-*): one colour per area, used for the area tiles, the
// open-issues chart and the feed, so an area keeps its colour everywhere on the page.
export const VIVID = {
  rose: "var(--soc-v-rose)",
  orange: "var(--soc-v-orange)",
  amber: "var(--soc-v-amber)",
  violet: "var(--soc-v-violet)",
  sky: "var(--soc-v-sky)",
  teal: "var(--soc-v-teal)",
  indigo: "var(--soc-v-indigo)",
  pink: "var(--soc-v-pink)",
  green: "var(--soc-v-green)",
  blue: "var(--soc-v-blue)",
  slate: "var(--soc-v-slate)",
  fuchsia: "var(--soc-v-fuchsia)",
};

export const AREA_COLOR = {
  incidents: VIVID.rose,
  identity: VIVID.indigo,
  endpoint: VIVID.violet,
  cloud: VIVID.teal,
  cloudApps: VIVID.pink,
  siem: VIVID.slate,
  detectionRules: VIVID.blue,
  network: VIVID.orange,
  external: VIVID.sky,
  data: VIVID.green,
  email: VIVID.amber,
  agenticAi: VIVID.fuchsia,
};

// Heatmap ramp, fewest to most.
export const HEAT = ["var(--soc-heat-0)", "var(--soc-heat-1)", "var(--soc-heat-2)", "var(--soc-heat-3)", "var(--soc-heat-4)"];

// --border-color is 8% alpha, too faint for a ring segment.
export const NEUTRAL = "var(--text-muted)";

export const AXIS = { stroke: "var(--chart-axis)", tick: { fill: "var(--chart-axis)", fontSize: 12 } };

export const GRID = { stroke: "var(--chart-grid)", strokeDasharray: "3 3", vertical: false };

export const TOOLTIP = {
  contentStyle: {
    background: "var(--chart-tooltip-bg)",
    border: "1px solid var(--chart-tooltip-border)",
    borderRadius: 8,
  },
  labelStyle: { color: "var(--text-primary)" },
  itemStyle: { color: "var(--text-secondary)" },
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "2026-10-04T00:00:00Z" -> "Oct 4". Reads the date part only, with no timezone conversion, so a
// UTC day never shifts to the previous or next day in the viewer's timezone.
export const formatDay = (isoString) => {
  const [year, month, day] = String(isoString || "")
    .slice(0, 10)
    .split("-")
    .map((part) => parseInt(part, 10));
  if (!year || !month || !day || month < 1 || month > 12) return String(isoString || "");
  return `${MONTHS[month - 1]} ${day}`;
};
